import React, { useState, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faCaretDown, faCaretUp, faTimes } from '@fortawesome/free-solid-svg-icons';

import * as S from './styles';
import Dropdown from './Dropdown';

function SearchSelector({ destinations, destination, destinationCategory, onSelect }) {
    const [isOpen, changeIsOpen] = useState(false);
    const innerRef = useRef(null);
    const toggleIsOpen = useCallback(() => changeIsOpen(!isOpen), [isOpen]);
    const onClickReset = useCallback(
        (evt) => {
            evt.stopPropagation();
            if (typeof onSelect === 'function') {
                onSelect(null, null);
            }
        },
        [onSelect]
    );

    const filtratedDestinations = destinations;
    const selectedDestination = destination;
    const selectedDestinationCategory = destinationCategory;
    const isSelected = !!selectedDestination;
    const isSelectedAllActivities = isSelected && !selectedDestinationCategory;
    const selectedDestinationLabel =
        isSelected && selectedDestination ? selectedDestination.label : '';

    const selectedFullLabel =
        isSelected &&
        [
            [
                selectedDestinationLabel.substring(0, 15),
                selectedDestinationLabel.length > 15 ? '...' : '',
            ].join(''),
            isSelectedAllActivities ? 'All activities' : selectedDestinationCategory.name,
        ].join(' > ');

    return (
        <S.SearchSelector
            data-test-id="search-selector"
            className="header__searchSelector"
            ref={innerRef}
        >
            <S.Selector data-test-id="selector" isSelected={isSelected} onClick={toggleIsOpen}>
                <S.SelectorIcon data-test-id="icon">
                    <FontAwesomeIcon icon={faSearch} fixedWidth />
                </S.SelectorIcon>
                <S.SelectorSelected data-test-id="selected">
                    {!isSelected && <span>Select a destination</span>}
                    {isSelected && <span>{selectedFullLabel}</span>}
                </S.SelectorSelected>
                <S.SelectorDropdownIndicator data-test-id="indicators">
                    <React.Fragment key="times">
                        {isSelected && (
                            <S.SelectorDropdownIndicatorReset
                                data-test-id="times"
                                onClick={onClickReset}
                            >
                                <FontAwesomeIcon icon={faTimes} />
                            </S.SelectorDropdownIndicatorReset>
                        )}
                    </React.Fragment>
                    <React.Fragment>
                        {!isOpen && (
                            <FontAwesomeIcon data-test-id="caret" icon={faCaretDown} fixedWidth />
                        )}
                    </React.Fragment>
                    <React.Fragment>
                        {isOpen && (
                            <FontAwesomeIcon data-test-id="caret" icon={faCaretUp} fixedWidth />
                        )}
                    </React.Fragment>
                </S.SelectorDropdownIndicator>
            </S.Selector>

            <Dropdown
                isOpen={isOpen}
                onSelect={onSelect}
                changeIsOpen={changeIsOpen}
                destinations={filtratedDestinations}
                destination={selectedDestination}
                destinationCategory={selectedDestinationCategory}
                selectorRef={innerRef}
            />
        </S.SearchSelector>
    );
}

SearchSelector.propTypes = {
    destinations: PropTypes.array.isRequired,
    onSelect: PropTypes.func.isRequired,
    destination: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    }),
    destinationCategory: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    }),
};

export default React.memo(SearchSelector);
